import React, { useEffect, useRef, useState } from 'react';
import { DS } from './ds';
interface VerificationModalProps {
  email: string;
  onVerify: (email: string, name: string) => void;
  onCancel: () => void;
}
const CODE_TTL_MS = 10 * 60 * 1000;
export const VerificationModal = ({
  email,
  onVerify,
  onCancel
}: VerificationModalProps) => {
  const [step, setStep] = useState<'confirm' | 'code'>('confirm');
  const [verificationCode, setVerificationCode] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const timerRef = useRef<ReturnType<typeof setTimeout>>();
  const sendVerificationCode = async () => {
    setLoading(true);
    setError('');
    try {
      // Simulado: en producción este código lo genera y envía tu backend por email.
      const code = Math.random().toString().slice(2, 8);
      window.sessionStorage.setItem('verification_code', code);
      window.sessionStorage.setItem('verification_email', email);

      // eslint-disable-next-line no-console
      console.log('Código de verificación enviado (simulado):', code);
      setStep('code');
      timerRef.current = setTimeout(() => {
        window.sessionStorage.removeItem('verification_code');
        window.sessionStorage.removeItem('verification_email');
      }, CODE_TTL_MS);
    } catch {
      setError('Error al enviar el código. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };
  const verifyCode = async () => {
    if (!verificationCode.trim()) {
      setError('Ingresa el código de verificación');
      return;
    }
    if (!name.trim()) {
      setError('Ingresa tu nombre');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const savedCode = window.sessionStorage.getItem('verification_code');
      const savedEmail = window.sessionStorage.getItem('verification_email');
      if (verificationCode === savedCode && savedEmail === email) {
        window.sessionStorage.removeItem('verification_code');
        window.sessionStorage.removeItem('verification_email');
        if (timerRef.current) clearTimeout(timerRef.current);
        onVerify(email, name);
      } else {
        setError('Código incorrecto. Intenta de nuevo.');
      }
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
  return <div role="dialog" aria-modal="true" style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(11,31,36,0.5)',
    zIndex: 1200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  }} data-id="element-847" data-mp="g1893zkp6w9j">
      <div style={{
      background: '#fff',
      borderRadius: DS.radius.cardLg,
      padding: '40px',
      maxWidth: '420px',
      width: '100%',
      boxShadow: '0 20px 60px rgba(11,31,36,0.3)'
    }} data-id="element-848" data-mp="21gqtmn5etpq">
        {step === 'confirm' ? <>
            <h2 style={{
          fontFamily: DS.font.heading,
          fontSize: '22px',
          fontWeight: 700,
          color: DS.color.ink,
          margin: '0 0 8px'
        }} data-id="element-849" data-mp="23x61s3di9idb">
              Verifica tu email
            </h2>

            <p style={{
          fontFamily: DS.font.body,
          fontSize: '14px',
          color: DS.color.body,
          margin: '0 0 28px'
        }} data-id="element-850" data-mp="2ilkgbbkaav9p">
              Enviaremos un código de verificación a <strong data-id="element-851" data-mp="1uwhudrimag9e">{email}</strong>
            </p>

            {error && <div role="alert" style={{
          padding: '12px',
          background: 'rgba(229,57,53,0.08)',
          border: '1px solid rgba(229,57,53,0.3)',
          borderRadius: '10px',
          color: DS.color.error,
          fontFamily: DS.font.body,
          fontSize: '12px',
          marginBottom: '16px'
        }} data-id="element-852" data-mp="1zwdq73h5v1dv">
                {error}
              </div>}

            <div style={{
          display: 'flex',
          gap: '12px'
        }} data-id="element-853" data-mp="3iusecz32op2w">
              <button type="button" onClick={onCancel} disabled={loading} style={{
            flex: 1,
            padding: '12px',
            background: 'transparent',
            color: DS.color.body,
            border: `2px solid ${DS.color.border}`,
            borderRadius: '12px',
            fontFamily: DS.font.body,
            fontSize: '14px',
            fontWeight: 700,
            cursor: 'pointer',
            opacity: loading ? 0.5 : 1
          }} data-id="element-854" data-mp="3is606glofbbp">
                Cancelar
              </button>

              <button type="button" onClick={sendVerificationCode} disabled={loading} style={{
            flex: 1,
            padding: '12px',
            background: '#00AAD4',
            color: '#fff',
            border: 'none',
            borderRadius: '12px',
            fontFamily: DS.font.body,
            fontSize: '14px',
            fontWeight: 700,
            cursor: 'pointer',
            opacity: loading ? 0.7 : 1
          }} data-id="element-855" data-mp="agjviiqcrcnx">
                {loading ? 'Enviando...' : 'Enviar código'}
              </button>
            </div>
          </> : <>
            <h2 style={{
          fontFamily: DS.font.heading,
          fontSize: '22px',
          fontWeight: 700,
          color: DS.color.ink,
          margin: '0 0 8px'
        }} data-id="element-856" data-mp="6aoc9vymd148">
              Verifica tu identidad
            </h2>

            <p style={{
          fontFamily: DS.font.body,
          fontSize: '14px',
          color: DS.color.body,
          margin: '0 0 24px'
        }} data-id="element-857" data-mp="39e1c37npvkd0">
              Ingresa el código que recibiste y tu nombre profesional.
            </p>

            {error && <div role="alert" style={{
          padding: '12px',
          background: 'rgba(229,57,53,0.08)',
          border: '1px solid rgba(229,57,53,0.3)',
          borderRadius: '10px',
          color: DS.color.error,
          fontFamily: DS.font.body,
          fontSize: '12px',
          marginBottom: '16px'
        }} data-id="element-858" data-mp="2upy6hzdl6aoq">
                {error}
              </div>}

            <label htmlFor="verification-name" style={{
          display: 'block',
          fontFamily: DS.font.body,
          fontSize: '12px',
          fontWeight: 700,
          color: DS.color.muted,
          marginBottom: '6px'
        }} data-id="element-859" data-mp="270c7pd14lxh9">
              Nombre profesional
            </label>
            <input id="verification-name" type="text" placeholder="Tu nombre profesional" value={name} onChange={e => setName(e.target.value)} style={{
          width: '100%',
          padding: '12px',
          border: `2px solid ${DS.color.border}`,
          borderRadius: '12px',
          fontFamily: DS.font.body,
          fontSize: '14px',
          marginBottom: '14px',
          boxSizing: 'border-box',
          color: DS.color.ink
        }} data-id="element-860" data-mp="reibwcf0ahrl" />

            <label htmlFor="verification-code" style={{
          display: 'block',
          fontFamily: DS.font.body,
          fontSize: '12px',
          fontWeight: 700,
          color: DS.color.muted,
          marginBottom: '6px'
        }} data-id="element-861" data-mp="3c0224wzc98z8">
              Código de verificación
            </label>
            <input id="verification-code" type="text" inputMode="numeric" placeholder="000000" value={verificationCode} onChange={e => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))} maxLength={6} style={{
          width: '100%',
          padding: '12px',
          border: `2px solid ${DS.color.border}`,
          borderRadius: '12px',
          fontFamily: DS.font.body,
          fontSize: '15px',
          marginBottom: '24px',
          boxSizing: 'border-box',
          textAlign: 'center',
          letterSpacing: '4px',
          color: DS.color.ink
        }} data-id="element-862" data-mp="1we837nhx9d5c" />

            <div style={{
          display: 'flex',
          gap: '12px'
        }} data-id="element-863" data-mp="2wn6j29lwq43e">
              <button type="button" onClick={() => {
            setStep('confirm');
            setVerificationCode('');
            setError('');
          }} disabled={loading} style={{
            flex: 1,
            padding: '12px',
            background: 'transparent',
            color: DS.color.body,
            border: `2px solid ${DS.color.border}`,
            borderRadius: '12px',
            fontFamily: DS.font.body,
            fontSize: '14px',
            fontWeight: 700,
            cursor: 'pointer',
            opacity: loading ? 0.5 : 1
          }} data-id="element-864" data-mp="2worc1uskpez5">
                Atrás
              </button>

              <button type="button" onClick={verifyCode} disabled={loading} style={{
            flex: 1,
            padding: '12px',
            background: '#00AAD4',
            color: '#fff',
            border: 'none',
            borderRadius: '12px',
            fontFamily: DS.font.body,
            fontSize: '14px',
            fontWeight: 700,
            cursor: 'pointer',
            opacity: loading ? 0.7 : 1
          }} data-id="element-865" data-mp="20cddjgexynk">
                {loading ? 'Verificando...' : 'Verificar'}
              </button>
            </div>

            <p style={{
          fontFamily: DS.font.body,
          fontSize: '11px',
          color: DS.color.muted,
          textAlign: 'center',
          margin: '20px 0 0'
        }} data-id="element-866" data-mp="3qklsiezxn1al">
              Nota: en producción recibirás un email real con el código.
            </p>
          </>}
      </div>
    </div>;
};